export function listingPageNumber(page: unknown): number {
    return typeof page === 'string' && Number(page) > 0 ? Number(page) : 1;
}

export function isOutOfBoundsListingPage(requestedPage: number, totalPages: number): boolean {
    return requestedPage > 1 && requestedPage > totalPages;
}

export function shouldThrowMissingResource(document: unknown, error: unknown, redirected: boolean): boolean {
    return !redirected && (document == null || Boolean(error));
}
